export const SaveAllToindexBD = async (key, values) => {
  try {
    const existingData = getLocalStorage(key, true);
    const newData = existingData || [];
    newData.push(values);
    saveLocalStorage(key, newData, true);
  } catch (error) {
    console.error("Erro ao salvar no IndexedDB:", error);
  }
}

export const SaveIndexBD = async (key, values) => {
  try {
    saveLocalStorage(key, values, true);
  } catch (error) {
    console.error("Erro ao salvar no IndexedDB:", error);
  }
}

export const saveLocalStorage = (key, values, array = false) => {
  if (array)
    localStorage.setItem(key, JSON.stringify(values));
  else
    localStorage.setItem(key, values);
}
export const saveLocalStoragePrice = (key, values, array = false) => {
  const existingData = JSON.parse(localStorage.getItem(key)) || [];

  if (!array) {
    console.error("A opção 'array' deve ser verdadeira para salvar múltiplos valores.");
    return;
  }

  values.forEach((newItem) => {
    const index = existingData.findIndex((item) => item.id === newItem.id);

    if (Number(newItem.faixa) === Number(newItem.valorInicial)) {
      if (index !== -1) {
        existingData.splice(index, 1);
      }
    } else if (index !== -1) {
      if (existingData[index].faixa !== newItem.faixa) {
        existingData[index].faixa = newItem.faixa;
        existingData[index].valorInicial = newItem.valorInicial;
      }
    } else {
      existingData.push(newItem);
    }
  });

  // Salva o array atualizado no localStorage
  localStorage.setItem(key, JSON.stringify(existingData));
};


// export const saveLocalStoragePrice = (key, values, array = false) => {
//   const existing = JSON.parse(localStorage.getItem(key)) || [];
//   if (!array) {
//     console.error("A opção 'array' deve ser verdadeira para salvar múltiplos valores.");
//     return;
//   }
//   values.forEach((newItem) => {
//     const index = existing.findIndex((item) => item.id === newItem.id);

//     if (index !== -1) {
//       if (existing[index].faixa !== newItem.faixa) {
//         existing[index].faixa = newItem.faixa;
//       }
//     } else {
//       existing.push(newItem);
//     }
//   });
//   localStorage.setItem(key, JSON.stringify(existing));
// };



export const getLocalStorage = (key, array = false) => {
  let data = localStorage.getItem(key)
  if (array)
    return data === 'undefined' ? undefined : JSON.parse(data);
  else
    return data
}

export const removeLocalStorage = (key) => {
  localStorage.removeItem(key)
}

export const saveSessionStorage = (key, values, array = false) => {
  if (array)
    sessionStorage.setItem(key, JSON.stringify(values));
  else
    sessionStorage.setItem(key, values);
}

export const getSessionStorage = (key, array = false) => {
  let data = sessionStorage.getItem(key)
  if (array)
    return JSON.parse(data)
  else
    return data
}

export const removeSessionStorage = (key) => {
  sessionStorage.removeItem(key);
}